import { LOCAL_STORAGE_KEYS } from "../utils/constants";
import { invokeApi } from "../bl_libs/invokeApi";
import { use_e2ee } from "../utils/utils";

/**
 * CPC Government — Children's Assessment requests (API-09), admin side.
 *
 * Approving or declining RECORDS THE DECISION and nothing else: no workspace is
 * provisioned, no survey scheduled, no email sent. DQ still does all of that by
 * hand. The downstream flow is still being designed, so the decision is captured
 * now rather than lost, and acted on when that design lands.
 *
 * Search, status filter and paging all run on the server, so the browser never
 * holds more than one page.
 */
export const listCpcGovRequests = ({ search = '', status = '', page = 0, rows_per_page = 25 } = {}) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    return invokeApi({
        path: '/cpc_gov/admin/requests/list',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { search, status, page, rows_per_page },
    }, use_e2ee());
};

/** decision_note is required by the server when declining. */
export const decideCpcGovRequest = ({ request_id, status, decision_note = '' }) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));
    return invokeApi({
        path: '/cpc_gov/admin/requests/decision',
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        postData: { request_id, status, decision_note },
    }, use_e2ee());
};

export const REQUEST_STATUS = {
    REQUESTED: 'requested',
    APPROVED: 'approved',
    DECLINED: 'declined',
};

export const STATUS_LABEL = {
    requested: 'Requested',
    approved: 'Approved',
    declined: 'Declined',
};

export const STATUS_COLOR = {
    requested: { fg: '#0b5fa5', bg: '#e8f1fa' },
    approved: { fg: '#1b6b3a', bg: '#e7f4ec' },
    declined: { fg: '#a33224', bg: '#fbecea' },
};

/**
 * Mirrors the server's ALLOWED_TRANSITIONS. Both decided states are terminal, so
 * the buttons disappear once a decision is recorded — the server refuses the
 * change anyway, and offering a button that always errors is worse than none.
 */
export const ALLOWED_NEXT = {
    requested: [REQUEST_STATUS.APPROVED, REQUEST_STATUS.DECLINED],
    approved: [],
    declined: [],
};

/** Dropdown options. The empty value means "all", which the server ignores. */
export const STATUS_FILTERS = [
    { value: '', label: 'All statuses' },
    { value: REQUEST_STATUS.REQUESTED, label: 'Requested' },
    { value: REQUEST_STATUS.APPROVED, label: 'Approved' },
    { value: REQUEST_STATUS.DECLINED, label: 'Declined' },
];
